import { render } from "./CommunityIndexView.vue?vue&type=template&id=75f5c727"
import script from "./CommunityIndexView.vue?vue&type=script&lang=js"
export * from "./CommunityIndexView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__